import { render, staticRenderFns } from "./ChatterMainHoliday.vue?vue&type=template&id=0d94cc15"
import script from "./ChatterMainHoliday.vue?vue&type=script&lang=js"
export * from "./ChatterMainHoliday.vue?vue&type=script&lang=js"
import style0 from "./ChatterMainHoliday.vue?vue&type=style&index=0&id=0d94cc15&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports